import { GlobalDesignGroupAction } from '../types';
import { groupByGroupDefinitions } from '../common/grouping/defaultGroupingStrategy';

export const shadowGrouping: GlobalDesignGroupAction['grouping'] = {
  getGroupingStrategy: (editorPointers, getHost, componentsAPI) => {
    return () => {
      return groupByGroupDefinitions(
        editorPointers,
        'shadowStyles',
        getHost,
        componentsAPI,
      );
    };
  },
};
